import { Button } from "web/components"

export default function ViewDealButton({ respond }) {
  return (
    <Button variant="secondary_default" onClick={() => respond("goto_deal")}>
      View Deal
    </Button>
  )
}
